import Dialog from '@/global/guides/Dialog'
import { hasPermission } from '@/hooks/useBackendMenu'
import {
    createPerfilPermissaoSchema,
    PerfilPermissao,
    permissoes,
} from '@/service/api'
import { toast } from 'sonner'
import FormPerfilPermissao from '../forms/FormPerfilPermissao'

export default function AdicionarPerfilPermissao() {
    const { mutateAsync, isLoading } = permissoes.mutations.useCreate({
        invalidateQuery: true,
    })

    function handleSubmit(data: PerfilPermissao) {
        return mutateAsync(data, {
            onSuccess: () => {
                toast.success('Perfil adicionado com sucesso!')
            },
            onError: err => {
                toast.error(err.message)
            },
        })
    }

    return (
        <Dialog.Root
            onSubmit={handleSubmit}
            loading={isLoading}
            schema={createPerfilPermissaoSchema}
            height="auto"
            open={hasPermission(['create', 'Permissões'])}
            defaultValues={{
                appAbilities: [],
            }}
        >
            <Dialog.Title>Adicionar perfil de permissões</Dialog.Title>
            <Dialog.Content dividers>
                <FormPerfilPermissao />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
